import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../../services/auth.service';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../../components/LoadingSpinner';

const AuthConfirm = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const next = searchParams.get('next') || '/update-password';
  const { refreshProfile } = useAuth();

  useEffect(() => {
    const handleAuthConfirm = async (): Promise<void> => {
      try {
        const token_hash = searchParams.get('token_hash');
        const code = searchParams.get('code');
        const type = searchParams.get('type');

        if ((!token_hash && !code) || !type) {
          throw new Error('Missing token_hash/code or type');
        }

        let error: Error | null = null;
        if (code) {
          const { error: exchangeError } = await supabase.auth.exchangeCodeForSession(code);
          error = exchangeError as unknown as Error | null;
        } else if (token_hash) {
          const result = await supabase.auth.verifyOtp({
            token_hash,
            type: type as 'signup' | 'recovery' | 'magiclink' | 'email',
          });
          error = (result.error as unknown as Error) || null;
        }

        if (error) {
          throw error;
        }

        // Redirect after verification
        if (type === 'recovery') {
          navigate('/update-password', { replace: true });
        } else {
          navigate(next || '/dashboard', { replace: true });
        }
      } catch (error) {
        console.error('Error in auth confirmation:', error);
        navigate('/login');
      }
    };

    handleAuthConfirm();
  }, [refreshProfile, searchParams, next, navigate]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <LoadingSpinner size="lg" text="Verifying your request..." />
    </div>
  );
};

export default AuthConfirm;
